const getters = {
  getCart (store) {
    return store.cart ? store.cart : false
  },
  getCartProducts (store) {
    const products = store.cart && store.cart.cart_products
    return products && products.length ? products : []
  },
  getCartTemporal (state) {
    return state.cartTemporal
  },
  getDonationProducts (state) {
    return state.donationProducts
  },
  getOpenCart (state) {
    return state.openCart
  },
  getOpenCategories (state) {
    return state.openCategories
  },
  getOpenSearchBar (state) {
    return state.openSearchBar
  },
  getCartCommerceId (state) {
    return state.cartCommerceId
  },
  getOpenCouponModal (state) {
    return state.openCouponModal;
  },
  getOpenPromoExceededModal (state) {
    return state.openPromoExceededModal;
  },
  getLastPromoExceededProduct (state) {
    return state.lastPromoExceededProduct;
  },
  getFreeProducts (state) {
    return state.freeProducts
  },
  getUserValidCoupons (state) {
    return state.userValidCoupons
  },
  getOrdersWithCoupons (state) {
    return state.ordersWithCoupons;
  },
  getDaviviendaBins (state) {
    return state.daviviendaBins;
  },
  getCartDeletedProducts (state) {
    return state.cartDeledProducts;
  }
}

export default getters
